import { useCallback } from "react";
import { useDriveOnePickReturn } from "@/hooks/useDriveOnePickReturn";

interface UseKmChatDriveOnePickReturnOptions {
  enabled?: boolean;
  onUploadFile: (file: File, title?: string) => Promise<void>;
  onError?: (message: string) => void;
}

export function useKmChatDriveOnePickReturn({
  enabled = true,
  onUploadFile,
  onError,
}: UseKmChatDriveOnePickReturnOptions): void {
  const handleImport = useCallback(
    async ({ files }: { fileIds: string[]; files: File[] }) => {
      for (const file of files) {
        await onUploadFile(file, file.name);
      }
    },
    [onUploadFile]
  );

  useDriveOnePickReturn({
    enabled,
    onImport: handleImport,
    onError,
  });
}
